<div class="menu-countdown flexRowParent">
    <ac-svg class="menu-countdown-icon" name="countdown"></ac-svg>
    <div class="menu-countdown-title">Countdown</div>
    <div class="menu-countdown-timer">
        <countdown [config]="{stopTime: acTimeStamp}">$!h!h $!m!m $!s!s</countdown>
    </div>
</div>
